import { ISurveyService } from 'models';

export const getUpdatedServicesList = (
	activeServices: number[],
	newPartnerServices?: ISurveyService[],
) => {
	if (!newPartnerServices || !newPartnerServices.length) {
		return activeServices;
	}
	const newServicesInitialIds = newPartnerServices.map((i) => i.parentId);

	return activeServices.reduce((res: number[], activeServiceId: number) => {
		if (newServicesInitialIds.includes(activeServiceId)) {
			const newServiceId = newPartnerServices.find(
				(i) => i.parentId === activeServiceId,
			)!.id;

			res.push(newServiceId);
		} else {
			res.push(activeServiceId);
		}

		return res;
	}, []);
};

export const getUpdatedService = (
	service: Partial<ISurveyService>,
	newPartnerServices?: ISurveyService[],
) => {
	if (!newPartnerServices || !newPartnerServices.length) return service;

	const newServicesInitialIds = newPartnerServices.map((i) => i.parentId);

	if (newServicesInitialIds.includes(service.id as number)) {
		return {
			...service,
			id: newPartnerServices.find((i) => service.id === i.parentId)!.id,
		};
	}
	return service;
};

export const getInitialServiceId = (
	id: number,
	newServices?: ISurveyService[],
) => {
	if (!newServices || !newServices.length) return id;

	const newServicesIds = newServices.map((i) => i.id);

	if (newServicesIds.includes(id)) {
		return newServices.find((s) => s.id === id)!.parentId;
	}
};
